export enum ChaletNameEnum {
    PetitePia = "PetitePia",
    PiaChaletPlusApt = "PiaChaletPlusApt",
    LesLoups = "LesLoups",
    Galta = "Galta",
    Alya = "Alya",
    LesSolans = "LesSolans",
    EtoileDesNeiges = "EtoileDesNeiges",
}

export interface Availability {
    Id: number;
    name: ChaletNameEnum;
    arrivalDate: Date
    departureDate: Date
    duration: number
    minPax: number
    maxPax: number
    schoolHoliday: string
    originalPrice: number
    currentPrice: number
    discount: number
    notes: string

    productEnhancements: string

    isFullyBooked: boolean

    roomsBooked: boolean[],
    isPricePerPerson: boolean,
    hasAnnex?: boolean;
}